import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { TokenStorageService } from '../auth/token-storage.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth         = inject(AuthService);
  const tokenStorage = inject(TokenStorageService);
  const router       = inject(Router);

  const token = tokenStorage.getAccessToken();

  if (token && !auth.isTokenExpired(token)) {
    return true;
  }

  if (state?.url && !state.url.startsWith('/auth')) {
    sessionStorage.setItem('returnUrl', state.url);
  }

  return router.createUrlTree(['/auth/login']);
};

